import React, { FC } from "react";

import { Icon } from "../../common";

type Props = {
  label: string;
  link: string;
};

export const BlockchainExplorerLink: FC<Props> = ({ label, link }) => (
  <a
    href={link}
    target="_blank"
    rel="noreferrer"
    className="flex items-center whitespace-nowrap gap-1 text-purple-700"
  >
    {label}
    <Icon icon="launch" size={16} />
  </a>
);
